import React, { useRef } from 'react';
import HdModal from '../../../../modal/components/modal/HdModal';
import {
  CollapsibleWorkbenchQueryEditor,
  WorkbenchQueryEditorProps
} from './CollapsibleWorkbenchQueryEditor';

export interface WorkbenchQueryEditorDialogProps extends WorkbenchQueryEditorProps {
  toggleExpandedView: Function;
  open?: boolean;
}

export function WorkbenchQueryEditorDialog({ open, ...props }: WorkbenchQueryEditorDialogProps) {
  const editorRef = useRef(null);

  return (
    <HdModal
      open={open}
      onClose={() => props.toggleExpandedView()}
      contentClassName='surface-on-surface'
      placement='top'
      styling={{
        width: '1170px',
        maxWidth: '100%',
        marginTop: '100px',
        display: 'flex'
      }}
      onTransitionEnd={() => { editorRef.current.refresh(); }}
    >
      <CollapsibleWorkbenchQueryEditor
        {...props}
        editorRef={editorRef}
        className='flex-1'
        isExpandedView={true}
      />
    </HdModal>
  );
}
